<app-breadcrumb [master]="'Administracja'" [parentName]="'Usunięte'" [name]="'Lista'"></app-breadcrumb>

<div class="log-deleted-data--list-container" >
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" >

    <mat-form-field appearance="standard" class="log-deleted-data--list-filter" >
      <mat-label>Rodzaj</mat-label>
      <mat-select [(ngModel)]="initialFilters.entity" name="entity">
        <mat-option *ngFor="let entity of ENTITY_TYPES" [value]="entity.value">{{entity.label}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="log-deleted-data--list-filter">
      <mat-label>Użytkownik</mat-label>
      <input matInput placeholder="JanKow123" name="username" [(ngModel)]="initialFilters.username">
    </mat-form-field>

    <app-datepicker
      class="log-deleted-data--list-filter"
      label="Data usunięcia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="log-deleted-data--list-filter"
      label="Data usunięcia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>
  </form>

  <div class="log-deleted-data--list-buttons">
    <button (click)="filter()" mat-raised-button color="primary">
      <mat-icon>search</mat-icon> <span> Szukaj</span>
    </button>


    <button (click)="resetFilters()" mat-raised-button color="warn">
      <mat-icon>delete</mat-icon> <span> Resetuj filtry</span>
    </button>
  </div>

  <table mat-table [dataSource]="logs" matSort (matSortChange)="sortChanged($event)">

    <ng-container matColumnDef="entity">
      <th mat-header-cell *matHeaderCellDef> Rodzaj </th>
      <td mat-cell *matCellDef="let element">
         {{getEntityLabel(element.entity) || element.entity}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="createdAt"> Data utworzenia </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd HH:mm'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="note">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="note"> Notatka </th>
      <td mat-cell *matCellDef="let element" class="log-deleted-data--list-note">
        {{element.note}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.user">
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.user.uuid]">{{element.user.firstName}} {{element.user.lastName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="isSoftDeletedEntity(element.entity)" mat-icon-button (click)="restoreRecord(element)">
          <span matTooltip="Przywróć"   >
          <mat-icon>history</mat-icon>
          </span>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
